import { useLocation } from 'react-router-dom';

import {
  normalizeOpinionsFiltersToApiParams,
  CourtSearchPage,
  useOpinionsSearch,
  useQueryParams,
} from '../shared';
import { type OpinionsResponse } from '../types';

import { OpinionsResults } from './OpinionsResults';
import {
  OpinionsSearchForm,
  type OpinionsSearchFormData,
  type OpinionsSearchType,
} from './OpinionsSearchForm';

const OPINIONS_QUERY_PREFIX_MAP: Record<string, OpinionsSearchType> = {
  'citation:': 'citation',
  'docketNumber:': 'docketNumber',
  'caseName:': 'caseName',
  'judge:': 'judgeName',
};

export const OpinionsSearch = () => {
  const { search } = useLocation();
  const queryParams = useQueryParams(search);
  const query = queryParams.get('query') || '';
  const exactMatchParam = queryParams.get('exact_match');
  const initialExactMatch = exactMatchParam !== 'false';

  const normalizeFilters = (filters: unknown) =>
    normalizeOpinionsFiltersToApiParams(
      filters as Parameters<typeof normalizeOpinionsFiltersToApiParams>[0]
    );

  return (
    <CourtSearchPage<
      OpinionsResponse,
      OpinionsSearchFormData,
      OpinionsSearchType
    >
      queryPrefixMap={OPINIONS_QUERY_PREFIX_MAP}
      normalizeFilters={normalizeFilters}
      useSearchHook={useOpinionsSearch}
      initialQuery={query}
      initialExactMatch={initialExactMatch}
      SearchForm={OpinionsSearchForm}
      ResultsComponent={OpinionsResults}
    />
  );
};
